import type { ColumnKey, SortKey } from '../monitoringUtils';

interface MonitoringColumn {
    key: ColumnKey;
    sort?: SortKey;
    defaultOn: boolean;
    fixed?: boolean;
    width: number;
}

export const MONITORING_COLUMNS: MonitoringColumn[] = [
    { key: 'veic', sort: 'placa', defaultOn: true, fixed: true, width: 170 },
    { key: 'conta', sort: 'conta', defaultOn: true, width: 150 },
    { key: 'prox', sort: 'prox', defaultOn: true, width: 170 },
    { key: 'ult', sort: 'ult', defaultOn: true, width: 150 },
    { key: 'grupo', sort: 'grupo', defaultOn: false, width: 120 },
    { key: 'odo', sort: 'odo', defaultOn: true, width: 120 },
    { key: 'hor', sort: 'hor', defaultOn: false, width: 110 },
    { key: 'gar', sort: 'garantia', defaultOn: true, width: 110 },
    { key: 'svc', defaultOn: true, width: 160 },
    { key: 'conexao', sort: 'conexao', defaultOn: false, width: 100 },
    { key: 'camp', sort: 'camp', defaultOn: true, width: 120 },
    { key: 'acao', defaultOn: true, fixed: true, width: 100 },
];

export const FLEET_LEVEL_SORTS: SortKey[] = ['status', 'placa', 'conta'];
